const initialState = {
  sidebar: "responsive",
  asideShow: false,
  darkMode: false,
  showSideBar: true,
  isMobile: false,
};
const uiReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "set":
      return {
        ...state,
        ...actions.payload,
      };
    case "get":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default uiReducer;
